import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Code } from 'src/app/core/model/dictionary';
import { ToastrService } from 'ngx-toastr';
import { CommunityServiceCategoryService } from 'src/app/core/service/community-service-category.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { CommunityServiceCorrectionEmail } from 'src/app/shared/community-service-info/community-service-correction-email';

@Component({
  selector: 'app-community-service-correction',
  templateUrl: './community-service-correction.component.html',
  styleUrls: ['./community-service-correction.component.scss']
})
export class CommunityServiceCorrectionComponent implements OnInit
{
  @Input() public serviceId: number;
  @Input() public serviceName: string;
  @Input() public serviceAddress: string;
  @Input() public managerName: string;
  @Input() public managerEmail: string;
  @Input() public managerNotificationPreference: string;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();

  public correctionForm: any;
  public correctionFormActive = false;
  public communityServiceCorrectionTypes: Code[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private dictionaryService: DictionaryService,
    private toastrService: ToastrService,
    private communityServiceCategoryService: CommunityServiceCategoryService,
    private translate: TranslateService,
    private messageHandlerService: MessageHandlerService)
  { }

  public get correctionType(): UntypedFormControl
  {
    return this.correctionForm.get('correctionType');
  }

  public get correctionDescription(): UntypedFormControl
  {
    return this.correctionForm.get('correctionDescription');
  }

  public ngOnInit(): void
  {
    // get list of community service correction types from Dictionary table
    this.dictionaryService.getCachedCommunityServiceCorrectionTypes().subscribe({
      next: (data) =>
      {
        this.communityServiceCorrectionTypes = data;
      }
    });

    // Set form
    this.correctionForm = this.fb.group({
      correctionType: [{ value: null, disabled: false }, Validators.required],
      correctionDescription: [{ value: null, disabled: false }, Validators.required],
    });
    this.correctionFormActive = true;
  }

  public onSend(e: Event): void
  {
    e.preventDefault();

    // send email
    const communityServiceCorrectionEmail: CommunityServiceCorrectionEmail = {
      directoryManagerName: this.managerName,
      directoryManagerEmail: this.managerEmail,
      correctionType: this.correctionType.value.displayName,
      description: this.correctionDescription.value,
      serviceName: this.serviceName,
      serviceAddress: this.serviceAddress,
      directoryManagerNotificationPreference: this.managerNotificationPreference,
      communityProviderProgramId: this.serviceId
    };

    this.communityServiceCategoryService.sendCommunityServiceCorrectionByEmail(communityServiceCorrectionEmail).subscribe({
      next: () =>
      {
        if (this.managerNotificationPreference == "IMMEDIATE")
        {
          this.translate.get('CORRECTION-REPORTED-TO').subscribe({
            next: (res) =>
            {
              this.toastrService.success(res.replace('{{email}}', this.managerEmail), null,
                {
                  enableHtml: true,
                  timeOut: 5000
                });
            }
          });
        }
        else
        {
          this.messageHandlerService.displaySuccess('CORRECTION-SAVED-FUTURE-SUBMISSION');
        }
        this.closeCorrectionForm();
      },
      error: (errorResponse) =>
      {
        this.closeCorrectionForm();
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeCorrectionForm();
  }

  private closeCorrectionForm(): void
  {
    this.correctionFormActive = false;
    this.cancelling.emit();
  }

}
